import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-cookie-content',
  imports: [],
  templateUrl: './cookie-content.component.html',
  styleUrl: './cookie-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CookieContentComponent {
  private readonly sanitizer = inject(DomSanitizer);
  public readonly cookieUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    'https://autotaxatiepartners.nl/cookie-statement-2/'
  );
}
